import {BasePage, page, playVideo} from "./BasePage";
import {FramedVideo} from "../components/FramedVideo";
import {A1} from "../../assets/A1/ani";
import {A2} from "../../assets/A2/ani";
import {A3} from "../../assets/A3/ani";
import {A4} from "../../assets/A4/ani";

@page("Introduction")
export class Introduction extends BasePage {

	protected get data() {
		return {
			content: `PokerDAO is a utility-enabled art card with an initial drop of 10600 unique NFTs generated on the Ethereum Blockchain.
Your PokerDAO NFT will double as your membership card, as well as unlocks private club membership and additional benefits. Future areas and perks can be unlocked by the community through roadmap activations.
When purchasing a PokerDAO NFT, you’re not simply buying a provably rare piece of art. You are gaining membership access to a club whose benefits and offerings will increase over time. Your PokerDAO NFT will serve as your digital identity and open the digital doors to the Texas Hold’em metaverse for you.

10,400 cards are K-A cards. The other 200 cards are blank, customized cards, in the future we will express how we plan to use them. Players who hold a PokerDAO NFT will hold more equity at the Texas Hold'em game table`
		};
	}

	protected webContent() {
		// 在这里完善内容
		return <div>
			<div className="left">
				<div className="poker-container">
					{/*<div className="background"/>*/}
					<img className="background" src={require("../../assets/empty.png")}/>
					{/*<div className="shine blue-shine"/>*/}
					{/*<img className="poker" src={require("../../assets/poker4.png")}/>*/}
					{/*<video className="video video1" loop*/}
					{/*			 controls controlsList='nofullscreen nodownload noremote footbar'*/}
					{/*			 src={require("../../assets/card1-c.mp4")}*/}
					{/*			 onLoadedMetadata={playVideo} onClick={playVideo}/>*/}
					{/*<video className="video video2" loop*/}
					{/*			 controls controlsList='nofullscreen nodownload noremote footbar'*/}
					{/*			 src={require("../../assets/card5-c.mp4")}*/}
					{/*			 onLoadedMetadata={playVideo} onClick={playVideo}/>*/}
					{/*<video className="video video3" loop*/}
					{/*			 controls controlsList='nofullscreen nodownload noremote footbar'*/}
					{/*			 src={require("../../assets/card3-c.mp4")}*/}
					{/*			 onLoadedMetadata={playVideo} onClick={playVideo}/>*/}
					<FramedVideo className="video video1" root={A1} spacing={2}/>
					<FramedVideo className="video video2" root={A2} spacing={2}/>
					<FramedVideo className="video video3" root={A3} spacing={2}/>
					<FramedVideo className="video video4" root={A4} spacing={2}/>
					{/*<img className="video video1" src={require("../../assets/A1.gif")}/>*/}
					{/*<img className="video video2" src={require("../../assets/A2.gif")}/>*/}
					{/*<img className="video video3" src={require("../../assets/A3.gif")}/>*/}
					{/*<img className="video video4" src={require("../../assets/A4.gif")}/>*/}
				</div>
			</div>
			<div className="right">
				<div className="shine red-shine"/>
				<div className="text">
					<div className="title">
						THE POKERDAO<br/> NFT
					</div>
					<div className="content">{this.data.content}</div>
				</div>
			</div>
		</div>
	}

	protected mobileContent(): JSX.Element {
		return  <div>
			<div className="up">
				{/*<div className="shine red-shine"/>*/}
				<div className="text">
					<div className="title">
						THE POKERDAO<br/> NFT
					</div>
					<div className="content">{this.data.content}</div>
				</div>
			</div>
			<div className="down">
				<div className="poker-container">
					<img className="background" src={require("../../assets/empty.png")}/>
					{/*<img className="poker" src={require("../../assets/poker4.png")}/>*/}
					{/*<video className="video video1" loop*/}
					{/*			 controls controlsList='nofullscreen nodownload noremote footbar'*/}
					{/*			 src={require("../../assets/card1-c.mp4")}*/}
					{/*			 onLoadedMetadata={playVideo} onClick={playVideo}/>*/}
					{/*<video className="video video2" loop*/}
					{/*			 controls controlsList='nofullscreen nodownload noremote footbar'*/}
					{/*			 src={require("../../assets/card5-c.mp4")}*/}
					{/*			 onLoadedMetadata={playVideo} onClick={playVideo}/>*/}
					{/*<video className="video video3" loop*/}
					{/*			 controls controlsList='nofullscreen nodownload noremote footbar'*/}
					{/*			 src={require("../../assets/card3-c.mp4")}*/}
					{/*			 onLoadedMetadata={playVideo} onClick={playVideo}/>*/}
					<FramedVideo className="video video1" root={A1} spacing={2}/>
					<FramedVideo className="video video2" root={A2} spacing={2}/>
					<FramedVideo className="video video3" root={A3} spacing={2}/>
					<FramedVideo className="video video4" root={A4} spacing={2}/>
					{/*<img className="video video1" src={require("../../assets/A1.gif")}/>*/}
					{/*<img className="video video2" src={require("../../assets/A2.gif")}/>*/}
					{/*<img className="video video3" src={require("../../assets/A3.gif")}/>*/}
					{/*<img className="video video4" src={require("../../assets/A4.gif")}/>*/}
				</div>
				{/*<div className="shine blue-shine"/>*/}
			</div>

		</div>
	}
}
